import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "data-name": "Layer 1",
  viewBox: "0 0 110.01 122.86"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M109.55 42.18H.47a.47.47 0 0 0-.47.47v79.75c0 .25.22.46.47.46h109.08c.25 0 .46-.21.46-.46V42.64c0-.25-.2-.46-.46-.46M83.59 14.3V4.13c0-2.26-2.37-4.13-5.26-4.13s-5.25 1.86-5.25 4.13V14.3l.03.39h10.45z",
      class: "i408865131__cls-1"
    }, null, -1),
    _createElementVNode("path", {
      d: "M108.14 14.68H83.56l.01.01.03.41v10.63c0 2.26-2.38 3.66-5.27 3.66s-5.25-1.86-5.25-4.13V15.1l.03-.41H34.53l.03-.39V4.13C34.56 1.87 32.19 0 29.3 0s-5.26 1.86-5.26 4.13V14.3l.03.39H1.87A1.85 1.85 0 0 0 0 16.54V36c0 1.03.84 1.87 1.87 1.88h106.27c1.03 0 1.87-.84 1.87-1.87V16.55c0-1.03-.84-1.87-1.87-1.87M34.55 25.73c0 2.26-2.37 3.66-5.26 3.66s-5.25-1.86-5.25-4.13V15.1l.03-.41h10.45l.03.41z",
      class: "i408865131__cls-1"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "calendar-blank"}) } }